import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { injectTranslation } from "@app/shared/i18n/translation-scope";
import { scope as assetManagementScope } from "@app/assetmanagement/i18n/scope";
import { scope } from "@app/shared/organisms/cerrix-linked-item-table/i18n/scope";
import {
    LinkedItemTableOverviewDirective,
    LinkedItemTableDetailDirective,
} from "@app/shared/organisms/cerrix-linked-item-table/linked-item-table-template-context.directive";
import {
    LinkedItemTableCellContext,
    LinkedItemTableDetailContext,
    LinkedItemTableTemplates,
} from "@app/shared/organisms/cerrix-linked-item-table/linked-item-table-template.models";
import { CerrixColorBoxLabelComponent } from "@app/shared/molecules/cerrix-color-box-label/cerrix-color-box-label.component";
import { LinkedControlTableItem, LinkedControlTableDetails } from "./linked-control-table.models";

@Component({
    selector: "app-linked-control-row",
    imports: [
        LinkedItemTableOverviewDirective,
        LinkedItemTableDetailDirective,
        CerrixColorBoxLabelComponent,
        TranslatePipe,
    ],
    viewProviders: [provideTranslationScope(scope)],
    styleUrl:
        "../../../../shared/organisms/cerrix-linked-item-table/shared/linked-item-table-renderers.scss",
    templateUrl: "./linked-control-row.component.html",
})
export class LinkedControlRowComponent
    implements OnInit, LinkedItemTableTemplates<LinkedControlTableItem, LinkedControlTableDetails>
{
    private readonly translation = injectTranslation(assetManagementScope);
    private headers = { name: "", score: "" };
    protected readonly assetManagementScope = assetManagementScope;
    @ViewChild("overviewRow", { static: true }) overviewRow: TemplateRef<
        LinkedItemTableCellContext<LinkedControlTableItem>
    >;
    @ViewChild("detailRow", { static: true }) detailRow: TemplateRef<
        LinkedItemTableDetailContext<LinkedControlTableItem, LinkedControlTableDetails>
    >;
    readonly itemKey = (item: LinkedControlTableItem) => item.id;
    readonly detailContext: LinkedItemTableDetailContext<
        LinkedControlTableItem,
        LinkedControlTableDetails
    > | null = null;

    async ngOnInit(): Promise<void> {
        await this.translation.ready();
        this.headers = {
            name: this.translation.t("linkedItems.controls.nameHeader"),
            score: this.translation.t("linkedItems.controls.scoreHeader"),
        };
    }

    get columns(): LinkedItemTableTemplates<
        LinkedControlTableItem,
        LinkedControlTableDetails
    >["columns"] {
        return [
            { key: "name", header: this.headers.name },
            {
                key: "score",
                header: this.headers.score,
                width: "var(--linked-item-table-value-column-width)",
            },
        ];
    }
}
